import useSWR, { SWRResponse } from "swr";
import { Org } from "../../types";
import axios from "axios";
// @ts-ignore
import { configureOrganization, ORG_BASE_URL } from "../../constants";

const useOrg = (): SWRResponse<Org, Error> => {
  const data = useSWR(
    "org-theme",
    (): Promise<Org> =>
      axios.get(ORG_BASE_URL).then((res) => {
        const org = res.data.data as Org;
        configureOrganization(org);
        return org;
      }),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  );
  return { ...data };
};

export default useOrg;
